import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import classNames from 'classnames/bind';

// Components
import Heading from '../Heading';
import Subheading from '../Subheading';
import Button from '../Button';

// Router
import { getRoute } from '../../entry/routes';

// Icons
import cover from './assets/cover-new.png';

// Styles
import styles from './HalvedCard.styl';

const cx = classNames.bind(styles);

export default function HalvesCard(props) {
  const { className, name } = props;
  const { isPhone } = useSelector(state => state.responsive);

  return isPhone ? (
    <Link to={getRoute('halves')} className={cx('HalvesCardPhone', className)}>
      <div className={cx('HalvesCardPhone__body')}>
        <Heading className={cx('HalvesCardPhone__heading')} level={3}>
          <FormattedMessage id="halves.title" />
        </Heading>
        <Subheading className={cx('HalvesCardPhone__subheading')}>
          <FormattedMessage id="halves.slogan" />
        </Subheading>
        <Button className={cx('HalvesCardPhone__button')} secondary small>
          <FormattedMessage id="button.choosePizza" />
        </Button>
      </div>
      <LazyLoadImage className={cx('HalvesCardPhone__image')} src={cover} alt={name} />
    </Link>
  ) : (
    <div className={cx('HalvesCard', className)}>
      <Heading className={cx('HalvesCard__heading')} level={3}>
        {name}
      </Heading>
      <LazyLoadImage className={cx('HalvesCard__picture')} alt={name} src={cover} />
      <Button className={cx('HalvesCard__button')} to={getRoute('halves')} secondary>
        <FormattedMessage id="button.choosePizza" />
      </Button>
      <div className={cx('HalvesCard__note')}>
        <FormattedMessage id="halves.slogan" />
      </div>
    </div>
  );
}

HalvesCard.defaultProps = {
  className: '',
  name: '',
};

HalvesCard.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
};
